import React from 'react'

const DomainContext = React.createContext({})

export const DomainProvider = DomainContext.Provider;
export const DomainConsumer = DomainContext.Consumer;

export default DomainContext